/** Helpers for email template body HTML (Tiptap / backend). */

const _HTMLISH = /<[a-z][\s\S]*>/i;

/**
 * Convert legacy plain-text bodies to minimal HTML for the rich editor.
 * If `text` already looks like HTML, return unchanged.
 */
export function hydratePlainTextEmailBody(text: string): string {
  const raw = text ?? '';
  const trimmed = raw.trim();
  if (!trimmed) return '<p></p>';
  if (_HTMLISH.test(trimmed)) return raw;

  const escape = (s: string) =>
    s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');

  const blocks = raw.split(/\n\n+/);
  return blocks
    .map((block) => {
      const lines = escape(block).split('\n');
      return `<p>${lines.join('<br>')}</p>`;
    })
    .join('');
}

function stripTags(html: string): string {
  if (typeof DOMParser === 'undefined') {
    return html.replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim();
  }
  const doc = new DOMParser().parseFromString(html, 'text/html');
  return (doc.body.textContent || '').replace(/\s+/g, ' ').trim();
}

/** True if body is empty or only empty paragraphs / breaks. */
export function isEmailTemplateBodyEmpty(html: string): boolean {
  if (!html || !html.trim()) return true;
  const text = stripTags(html);
  return text.length === 0;
}

/** One-line preview for template list cards. */
export function emailTemplateBodyPreview(html: string, maxLen = 120): string {
  const t = stripTags(html);
  if (t.length <= maxLen) return t || '—';
  return `${t.slice(0, maxLen).trim()}…`;
}
